/** @format */

import axiosConfig from "../configs/axiosConfig";

export const uploadFile = async (formData) => {
  try {
    const response = await axiosConfig({
      method: "POST",
      url: "/public/upload.php",
      data: formData,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};

export const getprojects = async (page, pageSize) => {
  try {
    const response = await axiosConfig({
      method: "GET",
      url: "/project/get_all.php",
      params: {
        page: page,
        pageSize: pageSize,
      },
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};
export const getprojectbyid = async (id) => {
  try {
    const response = await axiosConfig({
      method: "GET",
      url: `/project/get_by_id.php`,
      params: {
        id: id,
      },
    });

    return response;
  } catch (error) {
    console.error(error.message);
  }
};

export const deleteprojectbyid = async (id) => {
  try {
    const response = await axiosConfig({
      method: "DELETE",
      url: `/project/delete.php`,
      data: {
        id: id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return "Fail";
  }
};

export const apiCreateproject = async (payload) => {
  // try {
  //   const response = await axiosConfig({
  //     method: "POST",
  //     url: "/blog",
  //     data: payload,
  //   });

  //   return response;
  // } catch (error) {
  //   console.error(error.message);
  // }
  const response = await axiosConfig({
    method: "POST",
    url: "/project/create.php",
    data: payload,
    transformRequest: [
      (data) => {
        return JSON.stringify(data);
      },
    ],
  });

  return response;
};

export const apiUpdateprojectByID = async (payload) => {
  const response = await axiosConfig({
    method: "PUT",
    url: `/project/update.php`,
    data: payload,
  });

  return response;
};
